// react
import React from "react";
import { useSelector } from "react-redux";

// third-party
import { Helmet } from "react-helmet-async";
import { FormattedMessage, useIntl } from "react-intl";

// application
import PageHeader from "../shared/PageHeader";

// data stubs
import theme from "../../data/theme";
import AppLink from "../shared/AppLink";

function SitePageContactUs() {
    const intl = useIntl();
    const breadcrumb = [
        { title: "Home", url: "" },
        { title: "About Us", url: "" },
    ];

    let companyInfo = useSelector((state) => state.generalInfo?.info);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`${intl.formatMessage({ id: "topbar.aboutUs", defaultMessage: "About Us" })} — ${theme.name}`}</title>
            </Helmet>

            <PageHeader header={<FormattedMessage id="topbar.aboutUs" defaultMessage="About Us" />} />

            <div className="block">
                <div className="container">
                    <div className="card mb-0 contact-us">
                        {/* <div className="contact-us__map">
                            <iframe
                                title="Google Map"
                                src={"https://maps.google.com/maps?q=Hup Soon Seremban Food Trading&output=embed"}
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                marginWidth="0"
                            />
                        </div> */}
                        <div className="card-body ">
                            <div className="contact-us__container">
                                <div className="row">
                                    <div className="col-12 d-flex flex-wrap align-items-center mb-5">
                                        {companyInfo?.company_logo ? (
                                            <img
                                                src={companyInfo?.company_logo}
                                                alt="logo"
                                                style={{ height: "auto", width: 95, marginLeft: -8 }}
                                            />
                                        ) : null}
                                        <h2 className="mb-0">
                                            {companyInfo?.company_name} 
                                            {/* <span style={{ fontSize: 17 }}>(923403-M)</span> */}
                                        </h2>
                                    </div>
                                    <p className="col-12 pb-3" style={{ lineHeight: 1.6 }}>
                                        <h4 className="contact-us__header card-title">
                                            <FormattedMessage id="company_background" defaultMessage="Company Background" />
                                        </h4>
                                        Hup Soon Seremban Food Trading Sdn. Bhd. (923403-M) is a retail convenience store chain that
                                        specializes in fresh pork and pork products. From our humble beginnings in the mid-2007s, Hup Soon
                                        has opened 21 branches and continues to grow progressively. We are committed to the uplifting of the
                                        retail pork market, transforming the traditional “pork stall at the wet market” image into one of a
                                        hygienic and professional pork supply service. In addition to pork products, Hup Soon stores also
                                        stock and sell various food such as dried foods and frozen foods items for a holistic shopping
                                        experience.
                                        <br />
                                        合顺芙蓉食品贸易有限公司(923403-M)是一家直营连锁便利店，它是从事一站式的新鲜猪肉与猪肉食品。从我们2007年中期开始，合顺已经开设了21间分店，并不断扩展。我们致力推广于零售猪肉市场的趋势，将传统的
                                        “湿市场猪肉”
                                        形象转变为卫生和专业猪肉供应服务之一。除了猪肉产品，合顺商店还存储和出售各种厨房食品，如干糧食品和冷冻食品，以实现整体购物体验。
                                    </p>
                                    <div className="col-12 col-lg-6 pb-4 pb-lg-0">
                                        <h4 className="contact-us__header card-title">
                                            <FormattedMessage id="footer.address" defaultMessage="Address" />
                                        </h4>

                                        <div className="contact-us__address">
                                            <p style={{ width: "80%" }}>
                                                {companyInfo?.company_address1 +
                                                    (companyInfo?.company_address2 ? companyInfo?.company_address2 : "")}
                                            </p>

                                            <h4 className="contact-us__header card-title pt-3">
                                                <FormattedMessage id="footer.contact" defaultMessage="Contact" />
                                            </h4>

                                            {companyInfo?.company_email ? (
                                                <>
                                                    <FormattedMessage id="footer.email" defaultMessage="Email" /> :
                                                    <a href={"mailto:" + companyInfo?.company_email}>{companyInfo?.company_email}</a>
                                                    <br />
                                                </>
                                            ) : null}
                                            {companyInfo?.company_tel ? (
                                                <>
                                                    {/* Tel : <a href={"tel:" + companyInfo?.company_tel}>{companyInfo?.company_tel}</a> */}
                                                    <FormattedMessage id="footer.tel" defaultMessage="Tel" /> : {companyInfo?.company_tel}
                                                </>
                                            ) : null}
                                            <br />
                                            {companyInfo?.company_fax ? (
                                                <>
                                                    <FormattedMessage id="footer.fax" defaultMessage="Fax" /> : {companyInfo?.company_fax}
                                                </>
                                            ) : null}
                                            <br />
                                            <br />
                                            {companyInfo?.company_website ? (
                                                <p>
                                                    <strong>
                                                        <FormattedMessage id="contactUs.website" defaultMessage="Website" />
                                                    </strong>
                                                    <br />
                                                    <AppLink to={companyInfo?.company_website} external target="_blank">
                                                        {companyInfo?.company_website}
                                                    </AppLink>
                                                </p>
                                            ) : null}

                                            {/* <p>
                                                <strong>
                                                    <FormattedMessage id="contactUs.open_hour_title" defaultMessage="Opening Hours" />
                                                </strong>
                                                <br />
                                                <FormattedMessage
                                                    id="contactUs.open_hour_data"
                                                    defaultMessage="Monday to Friday: 8.00 a.m. - 5.30 p.m."
                                                />
                                            </p> */}
                                        </div>
                                    </div>

                                    {/* <div className="col-12 col-lg-6">
                                        <h4 className="contact-us__header card-title">Leave us a Message</h4>

                                        <form>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="form-name">Your Name</label>
                                                    <input type="text" id="form-name" className="form-control" placeholder="Your Name" />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="form-email">Email</label>
                                                    <input
                                                        type="email"
                                                        id="form-email"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="form-subject">Subject</label>
                                                <input type="text" id="form-subject" className="form-control" placeholder="Subject" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="form-message">Message</label>
                                                <textarea id="form-message" className="form-control" rows="4" />
                                            </div>
                                            <button type="submit" className="btn btn-primary">
                                                Send Message
                                            </button>
                                        </form>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageContactUs;
